<template>
    <div>
        <form @submit.prevent="login">
            <div class="form-group mb-3">
                <input
                    :class="{ 'auth-input': true, 'is-invalid': errors.has('email') }"
                    :disabled="isLoggedIn() || loginSuccess"
                    :placeholder="translate('auth_login_placeholder_email')"
                    autocomplete="off"
                    name="email"
                    v-validate="'required|email'"
                    v-model="form.email"
                    type="email"
                />
                <div class="invalid-feedback">
                    <span v-if="errors.has('email')" class="has-error text-center">{{ errors.first('email') }}</span>
                </div>
            </div>
            <div v-if="devMode" class="form-group mb-3">
                <input
                    :class="{ 'auth-input': true, 'is-invalid': errors.has('password') }"
                    :disabled="isLoggedIn() || loginSuccess"
                    :placeholder="translate('auth_login_placeholder_password')"
                    autocomplete="off"
                    name="password"
                    type="password"
                    v-validate="'required|min:6'"
                    v-model="form.password"
                />
                <div class="invalid-feedback">
                    <span v-if="errors.has('password')" class="has-error text-center">{{
                        errors.first('password')
                    }}</span>
                </div>
            </div>
            <div class="form-group flex">
                <button class="auth-input mr-1 button" type="button" @click="toggleRegister">
                    {{
                        isSchoolPage()
                            ? translate('auth_login_button_register_teacher')
                            : translate('auth_login_button_register')
                    }}
                </button>
                <button class="auth-input ml-1 button" :disabled="isLoggedIn() || loginSuccess">
                    {{ translate('auth_login_button_login') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import appConfig from '@/app.config.js'
import Request from '@/lib/request.js'
import popup from '@/lib/popup.js'
import { isLoggedIn } from '@/lib/user.js'
import helperMixins from '@/mixins/helper.js'

export default {
    name: 'LoginForm',

    data() {
        return {
            loginSuccess: false,

            form: {
                email: '',
                password: ''
            }
        }
    },

    mixins: [helperMixins],

    methods: {
        isLoggedIn() {
            return isLoggedIn()
        },

        reset() {
            this.form = {
                email: '',
                password: ''
            }
        },

        toggleRegister() {
            this.$emit('toggle-register')
        },

        login() {
            if (!this.devMode) {
                this.$validator.validate().then(result => {
                    if (result) {
                        this.$emit('otp', this.form)
                        this.$emit('try-login')
                    }
                })
            } else {
                this.$validator.validate().then(result => {
                    if (!result) {
                        return false
                    }

                    const request = new Request()

                    this.$emit('try-login')

                    request
                        .post(appConfig.api.login, this.form)
                        .then(res => {
                            this.loginSuccess = true
                            this.$emit('success', res.data)
                        })
                        .catch(err => {
                            const res = err.response

                            this.$emit('fail')

                            if (res.status == 401) {
                                if (typeof res.data.data.status != 'undefined') {
                                    return popup.alert(
                                        res.data.data.status == 'suspended'
                                            ? this.translate('auth_login_alert_lock_account')
                                            : ''
                                    )
                                }

                                return popup.alert(this.translate('auth_login_alert_not_match'))
                            }
                        })
                })
            }
        }
    }
}
</script>

<style lang="scss">
.select-auth-box {
    column-gap: 16px;
}
</style>
